/**
 * CloudFront signed cookie helpers for user uploads.
 *
 * After login, the backend returns CloudFront signed cookies scoped to
 * the user's upload directory. These cookies are set on the CF domain
 * so that <img> tags pointing at CloudFront URLs automatically include
 * authentication via cookies.
 */

const CF_COOKIE_DOMAIN = '.talkyn.ai.xxz.dk';

interface CfCookieData {
  cookies: {
    'CloudFront-Policy': string;
    'CloudFront-Signature': string;
    'CloudFront-Key-Pair-Id': string;
  };
  cfDomain: string;
  expiresAt: string;
}

export function setCfCookies(data: CfCookieData | null): void {
  if (!data?.cookies) return;
  const expires = new Date(data.expiresAt).toUTCString();
  for (const [name, value] of Object.entries(data.cookies)) {
    document.cookie = `${name}=${value}; Domain=${CF_COOKIE_DOMAIN}; Path=/; Secure; SameSite=None; Expires=${expires}`;
  }
  // Store the CF domain so upload code can use it
  if (data.cfDomain) {
    localStorage.setItem('talkyn-cf-uploads-domain', data.cfDomain);
  }
}

export function clearCfCookies(): void {
  const names = ['CloudFront-Policy', 'CloudFront-Signature', 'CloudFront-Key-Pair-Id'];
  for (const name of names) {
    document.cookie = `${name}=; Domain=${CF_COOKIE_DOMAIN}; Path=/; Secure; SameSite=None; Max-Age=0`;
  }
  localStorage.removeItem('talkyn-cf-uploads-domain');
}

export function getCfUploadsDomain(): string | null {
  return localStorage.getItem('talkyn-cf-uploads-domain');
}
